import { defineMessages, FormattedMessage } from 'react-intl';

export const messages = defineMessages({
  payment: {
    id: 'payment.oney.payment',
    defaultMessage: 'Payment',
  },
  byCreditCard: {
    id: 'payment.oney.byCreditCard',
    defaultMessage: 'By credit card',
  },
  oneyBank: {
    id: 'payment.oney.bank',
    defaultMessage: "Oney Bank SA - capital of 40'741'215 EUR",
  },
  oneyHeadOffice: {
    id: 'payment.oney.headOffice',
    defaultMessage:
      "Head Office: 40 avenue de Fiandre 59'170 Croix - 546 380 197 RCS Lille Metropole - n°Orias 07023361 www.arias.fr",
  },
  oneyCorrespondence: {
    id: 'payment.oney.correspondence',
    defaultMessage:
      'Correspondence: CS 60 006 - 59895 Lille Cedey - www.oney.fr',
  },
});

export const OneyDescription = (
  minAmount: JSX.Element,
  maxAmount: JSX.Element,
) => (
  <FormattedMessage
    defaultMessage='Financing offer with mandatory down payment, reserved to individuals and valid for any purchase from {minAmount} to {maxAmount}. Subject to validation by Oney Bank. You have a delay of 14 days to abort your credit.'
    id='payment.oney.description'
    values={{
      minAmount,
      maxAmount,
    }}
  />
);
